import Head from "next/head";

export default function PersonvernErk() {
	return (
		<>
		<Head>
			<title>Personvern | Cherryblossom.no</title>
			<meta name="description" content="Les hvordan Cherryblossom.no håndterer personvern, informasjonskapsler og affiliatelenker." />
			<link rel="canonical" href="https://cherryblossom.no/personvern" />
			<meta property="og:url" content="https://cherryblossom.no/personvern" />
		</Head>
		<h1>Personvernserklæring</h1>
		<h2>Personlig data</h2>
		Cherryblossom.no samler ingen personlig informasjon slik som navn, adresse, telefonnummer eller e-postadresse.
		<h2>Informasjonskapsler og lignende teknologier</h2>
		Cherryblossom.no benytter seg av følgende affiliatenettverk:<br/>
		<ul>
			<li><a href="www.tradetracker.com" rel="nofollow">Tradetracker.com</a></li>
			<li><a href="www.partner-ads.com" rel="nofollow">Partner-ads.com</a></li>
			<li><a href="www.tradedoubler.com" rel="nofollow">Tradedoubler.com</a></li>
		</ul>
		Disse nettverkene bruker informasjonskapsler og lignende teknologier for å spore salg og besøk fra Cherryblossom.no til deres annonsører. Cherryblossom.no har ingen tilgang til eller kontroll over disse informasjonskapslene som brukes av tredjeparts annonsører. For mer informasjon om hvordan disse nettverkene bruker informasjonskapsler, vennligst se deres respektive personvernerklæringer.
		<h2>Kontakt oss</h2>
		Hvis du har spørsmål eller bekymringer angående vår personvernserklæring eller vår håndtering av dine personopplysninger, vennligst kontakt oss via følgende kontaktinformasjon: post@cherryblossom.no.
		
		<h3>Sist oppdatert</h3>
		23.07.2021
		<br/><br/>
		</>
	)
}
